import getDefaultState from './state';

export function flush(state) {
  Object.assign(state, getDefaultState());
}

export function updateCurrentAccount(state, { account }) {
  state.current = account;
}

export function updateAccounts(state, { accounts }) {
  state.all = accounts;
}
